/**
 * 对 OSS key/path 的最后一段（用户原始文件名）做 URLEncode，前缀路径保持不变。
 * @param {string} key OSS object key
 * @returns {string}
 */
export function encodeOssFileNameInPath(key) {
  const idx = key.lastIndexOf('/');
  if (idx < 0) return encodeURIComponent(key);
  return key.slice(0, idx + 1) + encodeURIComponent(key.slice(idx + 1));
}

/**
 * OSS 上传使用原始 key；提交/展示 URL 时再 encode 文件名。
 * @param {string} key OSS object key
 * @returns {string}
 */
export function finalizeOssUploadKey(key) {
  return key;
}

/**
 * 由 endpoint + 已 finalize 的 key 生成公开 URL，并 encode 最后一段文件名。
 * @param {string} endpoint
 * @param {string} key
 * @returns {string}
 */
export function buildOssPublicUrl(endpoint, key) {
  const base = endpoint.replace(/\/$/, '');
  return `${base}/${encodeOssFileNameInPath(key)}`;
}

/**
 * 仅用于前端预览防缓存；不改写入/入库的干净 URL。
 * 原地址已有 query 时用 `&`，否则用 `?`。
 * @param {string} url
 * @param {number} [ts=Date.now()]
 * @returns {string}
 */
export function withCacheBust(url, ts = Date.now()) {
  if (!url) return url;
  const sep = url.includes('?') ? '&' : '?';
  return `${url}${sep}t=${ts}`;
}
